module.exports = __webpack_public_path__ + "img/denimBlue.20b8b139.png";